var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_15691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6771 83.8984L28.3779 86.7537V91.7311V91.7969V91.8014H28.3781C28.3928 93.9953 29.7291 96.0881 32.4412 97.6539C38.4609 101.129 48.976 100.694 55.9271 96.6805C59.7309 94.4844 61.6791 91.6721 61.677 89.0061L61.6771 83.8984Z",
    fill: "url(#paint0_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9278 91.6011C48.9766 95.6142 38.4618 96.0501 32.4419 92.5745C26.4222 89.0989 27.177 83.0282 34.128 79.0151C41.079 75.0021 51.594 74.5661 57.6138 78.0415C63.6337 81.5169 62.8788 87.5878 55.9278 91.6011Z",
    fill: "#594A8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4666 40.8242L36.0469 44.5543L44.3621 63.4004L50.5785 59.7766C51.7404 59.2238 52.4871 57.7613 52.4871 55.6342V46.6098L42.4666 40.8242Z",
    fill: "url(#paint1_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.328 47.8711L47.893 49.2857V58.3102C47.893 60.2631 47.2628 61.6533 46.2606 62.2963L44.362 63.4031L44.3612 63.4016C43.4792 63.9254 42.3233 63.8859 41.0569 63.1547C40.5979 62.8898 40.1553 62.5449 39.7331 62.1471V85.5383C39.7135 86.2582 40.1327 86.9486 41.0204 87.4611C42.9368 88.5676 46.2844 88.4287 48.4973 87.1512C49.7551 86.425 50.3737 85.4873 50.3231 84.6098L50.328 47.8711Z",
    fill: "url(#paint2_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0674 50.34L36.0469 44.5547V53.5791C36.0469 57.2686 38.29 61.5545 41.0572 63.1521C43.8244 64.7498 46.0676 63.0539 46.0676 59.3645V50.34H46.0674Z",
    fill: "url(#paint3_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1598 53.4204C38.6885 53.0946 39.3848 53.1093 40.1504 53.5513C41.8012 54.5044 43.1393 57.0612 43.1393 59.2622C43.1393 60.4638 42.7385 61.3073 42.1076 61.6737L40.257 62.7895L36.3242 54.5179L38.1598 53.4204Z",
    fill: "url(#paint4_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.293 56.9308C35.293 59.1318 36.6312 61.6886 38.2818 62.6417C39.9326 63.5948 41.2707 62.5831 41.2707 60.3822C41.2707 58.1812 39.9326 55.6243 38.2818 54.6712C36.6312 53.7181 35.293 54.7298 35.293 56.9308Z",
    fill: "url(#paint5_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1328 57.4153C36.1328 58.9991 37.0957 60.8389 38.2836 61.5249C39.4715 62.2108 40.4344 61.4827 40.4344 59.8989C40.4344 58.3151 39.4715 56.4751 38.2836 55.7893C37.0957 55.1036 36.1328 55.8315 36.1328 57.4153Z",
    fill: "url(#paint6_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9358 34.8817L34.6421 10.0153C35.4954 6.29632 38.2681 3.31527 41.9155 2.19495L46.3989 0.817804C52.7317 -1.12751 59.6214 0.453547 64.4725 4.96527L68.205 8.43675C70.9989 11.0352 72.1944 14.927 71.3409 18.6459L65.6347 43.5123C64.7813 47.2313 62.0087 50.2123 58.3612 51.3326L53.8778 52.7098C47.545 54.6551 40.6554 53.0741 35.8042 48.5623L32.0718 45.0909C29.2778 42.4924 28.0825 38.6006 28.9358 34.8817Z",
    fill: "url(#paint7_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6069 34.7869L31.9477 31.3838C30.8239 30.3387 30.3431 28.7732 30.6862 27.2773L30.2446 29.2014C29.9015 30.6973 30.3823 32.2629 31.5061 33.308L35.1653 36.7111L35.6069 34.7869Z",
    fill: "url(#paint8_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4594 39.052L56.4527 41.5113C50.215 43.4273 43.4389 41.9201 38.6008 37.5631L38.1592 39.4875C42.9973 43.8445 49.7734 45.3518 56.0111 43.4355L64.0178 40.9762C65.485 40.5254 66.6002 39.3264 66.9436 37.8305L67.3852 35.9062C67.0418 37.4021 65.9266 38.6014 64.4594 39.052Z",
    fill: "url(#paint9_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.484 30.9354L32.8248 27.5322C31.701 26.4871 31.2201 24.9217 31.5633 23.4258L31.1217 25.3498C30.7783 26.8457 31.2592 28.4113 32.3832 29.4564L36.0424 32.8596L36.484 30.9354Z",
    fill: "url(#paint10_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3363 35.2004L57.3297 37.6598C51.092 39.5756 44.3158 38.0686 39.4777 33.7115L39.0361 35.6359C43.8742 39.993 50.6504 41.5002 56.8881 39.584L64.8947 37.1246C66.3619 36.6738 67.4771 35.4748 67.8205 33.9789L68.2621 32.0547C67.9187 33.5506 66.8035 34.7496 65.3363 35.2004Z",
    fill: "url(#paint11_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3676 27.0799L33.7084 23.6768C32.5846 22.6316 32.1037 21.0662 32.4469 19.5703L32.0055 21.4943C31.6621 22.9902 32.143 24.5559 33.2668 25.601L36.926 29.0041L37.3676 27.0799Z",
    fill: "url(#paint12_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2201 31.3449L58.2135 33.8043C51.9758 35.7201 45.1996 34.2131 40.3615 29.8561L39.9199 31.7805C44.758 36.1375 51.5342 37.6447 57.7719 35.7285L65.7785 33.2691C67.2457 32.8184 68.3609 31.6193 68.7043 30.1234L69.1459 28.1992C68.8025 29.6949 67.6873 30.8941 66.2201 31.3449Z",
    fill: "url(#paint13_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2515 23.24L34.5924 19.8369C33.4685 18.7918 32.9877 17.2264 33.3308 15.7305L32.8892 17.6545C32.5459 19.1504 33.0269 20.716 34.1508 21.7611L37.8099 25.1643L38.2515 23.24Z",
    fill: "url(#paint14_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1049 27.5051L59.0982 29.9645C52.8605 31.8803 46.0844 30.3732 41.2463 26.0162L40.8047 27.9406C45.6428 32.2977 52.4189 33.8049 58.6566 31.8887L66.6633 29.4293C68.1305 28.9785 69.2457 27.7795 69.5891 26.2836L70.0307 24.3594C69.6873 25.8553 68.5721 27.0543 67.1049 27.5051Z",
    fill: "url(#paint15_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1344 19.3846L35.4752 15.9814C34.3514 14.9363 33.8705 13.3709 34.2137 11.875L33.7721 13.799C33.4287 15.2949 33.9096 16.8605 35.0336 17.9057L38.6928 21.3088L39.1344 19.3846Z",
    fill: "url(#paint16_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9867 23.6496L59.9801 26.109C53.7424 28.0248 46.9662 26.5178 42.1281 22.1607L41.6865 24.0852C46.5246 28.4422 53.3008 29.9494 59.5385 28.0332L67.5451 25.5738C69.0123 25.123 70.1275 23.924 70.4707 22.4281L70.9123 20.5039C70.5691 21.9996 69.4539 23.1988 67.9867 23.6496Z",
    fill: "url(#paint17_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2463 46.9488L53.5967 45.4219L50.8199 46.2748L50.4764 47.7721C49.9592 50.026 48.7336 52.0057 47.0391 53.4676C47.5723 53.5078 48.1078 53.5252 48.6447 53.5189C50.942 52.0291 52.617 49.691 53.2463 46.9488Z",
    fill: "url(#paint18_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0166 46.1324C55.2682 49.3937 53.0436 52.0869 50.0479 53.4562C50.251 53.4385 50.4541 53.4172 50.657 53.3926L51.5133 53.1295C55.1607 52.009 57.9334 49.0279 58.7867 45.3092L59.1508 43.7227L56.3738 44.5758L56.0166 46.1324Z",
    fill: "url(#paint19_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5563 44.4809C60.7027 48.1998 57.9303 51.1809 54.2828 52.3014L51.6611 53.1066C51.9648 53.0301 52.268 52.9479 52.5695 52.8553L57.0529 51.4781C60.7004 50.3576 63.473 47.3766 64.3264 43.6576L64.7041 42.0117L61.9273 42.8646L61.5563 44.4809Z",
    fill: "url(#paint20_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9572 4.02635L60.6998 3.18396C57.2686 0.936112 53.19 -0.106272 49.1172 0.206814C48.2055 0.342557 47.2973 0.544705 46.4004 0.820291L45.3643 1.13865C49.7707 0.561502 54.2441 1.58474 57.9572 4.02635Z",
    fill: "url(#paint21_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9016 8.58789L63.4051 5.33594L60.6572 6.18008L64.1313 9.41113C66.9252 12.0096 68.1207 15.9014 67.2672 19.6201L66.6582 22.2734L69.4352 21.4205L70.0371 18.7969C70.891 15.0781 69.6955 11.1863 66.9016 8.58789Z",
    fill: "url(#paint22_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7662 1.93223L41.9188 2.19258C41.4688 2.33067 41.0326 2.49766 40.6113 2.69044C44.7836 2.32422 48.9725 3.38243 52.4768 5.70547L55.2199 4.8629C51.5486 2.43829 47.1293 1.40235 42.7662 1.93223Z",
    fill: "url(#paint23_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3623 10.2338L57.9107 7.02344L55.1631 7.86758L58.5924 11.057C61.3863 13.6555 62.5818 17.5473 61.7283 21.266L61.1057 23.9791L63.8826 23.126L64.4982 20.443C65.3518 16.724 64.1563 12.8322 61.3623 10.2338Z",
    fill: "url(#paint24_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2434 3.45044C38.834 3.71607 38.4453 4.00923 38.0781 4.32642C41.2432 4.56411 44.3193 5.60943 46.9928 7.39595L49.734 6.55396C46.6166 4.47857 42.9545 3.40786 39.2434 3.45044Z",
    fill: "url(#paint25_linear_331_15691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8207 11.8836L52.4137 8.71484L49.666 9.55879L53.0506 12.7068C55.8445 15.3053 57.04 19.1971 56.1865 22.9158L55.5502 25.6883L58.3271 24.8352L58.9564 22.0926C59.8102 18.3738 58.6148 14.482 55.8207 11.8836Z",
    fill: "url(#paint26_linear_331_15691)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_15691",
    x1: 31.1254,
    y1: 91.9494,
    x2: 60.7291,
    y2: 91.9494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E4990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_331_15691",
    x1: 44.267,
    y1: 38.4654,
    x2: 44.267,
    y2: 62.2467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_331_15691",
    x1: 45.0303,
    y1: 93.0689,
    x2: 45.0303,
    y2: 38.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_331_15691",
    x1: 41.057,
    y1: 45.8952,
    x2: 33.8916,
    y2: 58.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_331_15691",
    x1: 40.5047,
    y1: 58.0477,
    x2: 38.2629,
    y2: 54.1649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0438,
    stopColor: "#AE9CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3211,
    stopColor: "#CCC0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    stopColor: "#E1DAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8149,
    stopColor: "#EEEAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_331_15691",
    x1: 38.282,
    y1: 63.8427,
    x2: 38.282,
    y2: 53.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0438,
    stopColor: "#AE9CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3211,
    stopColor: "#CCC0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    stopColor: "#E1DAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8149,
    stopColor: "#EEEAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_331_15691",
    x1: 38.2836,
    y1: 57.2006,
    x2: 38.2836,
    y2: 61.4196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7662BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0621,
    stopColor: "#7B67C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4204,
    stopColor: "#9481D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7439,
    stopColor: "#A491E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A996EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_331_15691",
    x1: 43.653,
    y1: 25.3451,
    x2: 63.3688,
    y2: 29.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_331_15691",
    x1: 31.7917,
    y1: 31.8046,
    x2: 35.1781,
    y2: 32.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_331_15691",
    x1: 47.7423,
    y1: 37.8174,
    x2: 62.2201,
    y2: 41.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_331_15691",
    x1: 32.6698,
    y1: 27.9519,
    x2: 36.0564,
    y2: 28.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_331_15691",
    x1: 48.6203,
    y1: 33.9647,
    x2: 63.0981,
    y2: 37.2909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_331_15691",
    x1: 33.5545,
    y1: 24.0953,
    x2: 36.9411,
    y2: 24.8733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_331_15691",
    x1: 49.5053,
    y1: 30.1079,
    x2: 63.9831,
    y2: 33.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_331_15691",
    x1: 34.4399,
    y1: 20.2541,
    x2: 37.8265,
    y2: 21.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_331_15691",
    x1: 50.3912,
    y1: 26.267,
    x2: 64.869,
    y2: 29.5931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_331_15691",
    x1: 35.3237,
    y1: 16.3975,
    x2: 38.7103,
    y2: 17.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_331_15691",
    x1: 51.2743,
    y1: 22.4102,
    x2: 65.7521,
    y2: 25.7364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_331_15691",
    x1: 48.0587,
    y1: 49.0065,
    x2: 52.5357,
    y2: 50.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_331_15691",
    x1: 51.3167,
    y1: 47.9164,
    x2: 57.8441,
    y2: 49.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_331_15691",
    x1: 53.1782,
    y1: 46.4904,
    x2: 63.1526,
    y2: 48.7819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_331_15691",
    x1: 45.6429,
    y1: -0.0656505,
    x2: 60.6615,
    y2: 3.38478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_331_15691",
    x1: 59.205,
    y1: 12.5341,
    x2: 70.8701,
    y2: 15.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_331_15691",
    x1: 40.8262,
    y1: 1.75334,
    x2: 55.1819,
    y2: 5.05148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_331_15691",
    x1: 53.7046,
    y1: 14.236,
    x2: 65.3184,
    y2: 16.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_331_15691",
    x1: 38.1347,
    y1: 4.07312,
    x2: 49.6964,
    y2: 6.72936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_331_15691",
    x1: 48.2021,
    y1: 15.9416,
    x2: 59.7642,
    y2: 18.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43386B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_15691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic2);
export default __webpack_public_path__ + "static/media/mic2.b8ae16603000f9a2f05eefec2ec7916c.svg";
export { ForwardRef as ReactComponent };